export default __webpack_public_path__ + "static/mylogo-aec6eca01c3923dadda0bd61b3aac974.jpeg";